// Runtime config: reads from window.__CONFIG__ (injected by docker-entrypoint.sh in production)
// Falls back to process.env for local development (CRA bakes these at build time)
const config = window.__CONFIG__ || {};
const get = (key) => config[key] || process.env[key];

export default {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: get("REACT_APP_API_URL"),
  REACT_APP_COOKIE_URL: get("REACT_APP_COOKIE_URL"),
  REACT_APP_PRIMARY_COLOR: get("REACT_APP_PRIMARY_COLOR"),
  REACT_APP_LOGO_URL: get("REACT_APP_LOGO_URL"),
  REACT_APP_LOGIN_LOGO_URL: get("REACT_APP_LOGIN_LOGO_URL"),
  REACT_APP_GOOGLE_MAPS_API: get("REACT_APP_GOOGLE_MAPS_API"),
  REACT_APP_MIXPANEL_TOKEN: get("REACT_APP_MIXPANEL_TOKEN"),
  REACT_APP_PRIVACY_POLICY_URL: get("REACT_APP_PRIVACY_POLICY_URL"),
  REACT_APP_SMS_POLICY_URL: get("REACT_APP_SMS_POLICY_URL"),
  REACT_APP_CONTACT_PHONE_NUMBER: get("REACT_APP_CONTACT_PHONE_NUMBER"),
  REACT_APP_CONTACT_PHONE_NUMBER_RAW: get("REACT_APP_CONTACT_PHONE_NUMBER_RAW"),
  REACT_APP_DONATION_GUIDELINES_URL: get("REACT_APP_DONATION_GUIDELINES_URL"),
  REACT_APP_EMAIL_PLACEHOLDER: get("REACT_APP_EMAIL_PLACEHOLDER"),
  REACT_APP_THANK_YOU_REDIRECT: get("REACT_APP_THANK_YOU_REDIRECT"),
  REACT_APP_FAVICON_URL: get("REACT_APP_FAVICON_URL"),
  REACT_APP_BODY_CLASS: get("REACT_APP_BODY_CLASS"),
  REACT_APP_HOME_BG_IMAGE: get("REACT_APP_HOME_BG_IMAGE"),
  REACT_APP_LOGIN_BG_COLOR: get("REACT_APP_LOGIN_BG_COLOR"),
  REACT_APP_LOGIN_BG_IMAGE: get("REACT_APP_LOGIN_BG_IMAGE"),
  REACT_APP_SENTRY_DSN: get("REACT_APP_SENTRY_DSN"),
  REACT_APP_GTM_TOGGLE: get("REACT_APP_GTM_TOGGLE"),
  REACT_APP_GTM_ID: get("REACT_APP_GTM_ID"),
  REACT_APP_GOOGLE_ANALYTICS_TOGGLE: get("REACT_APP_GOOGLE_ANALYTICS_TOGGLE"),
  REACT_APP_GOOGLE_ANALYTICS: get("REACT_APP_GOOGLE_ANALYTICS"),
  REACT_APP_ORG_NAME: get("REACT_APP_ORG_NAME"),
};

export const REACT_APP_API_URL = get("REACT_APP_API_URL");
export const REACT_APP_COOKIE_URL = get("REACT_APP_COOKIE_URL");
export const REACT_APP_PRIMARY_COLOR = get("REACT_APP_PRIMARY_COLOR");
export const REACT_APP_LOGO_URL = get("REACT_APP_LOGO_URL");
export const REACT_APP_LOGIN_LOGO_URL = get("REACT_APP_LOGIN_LOGO_URL");
export const REACT_APP_GOOGLE_MAPS_API = get("REACT_APP_GOOGLE_MAPS_API");
export const REACT_APP_MIXPANEL_TOKEN = get("REACT_APP_MIXPANEL_TOKEN");
export const REACT_APP_PRIVACY_POLICY_URL = get("REACT_APP_PRIVACY_POLICY_URL");
export const REACT_APP_SMS_POLICY_URL = get("REACT_APP_SMS_POLICY_URL");
export const REACT_APP_CONTACT_PHONE_NUMBER = get("REACT_APP_CONTACT_PHONE_NUMBER");
export const REACT_APP_CONTACT_PHONE_NUMBER_RAW = get("REACT_APP_CONTACT_PHONE_NUMBER_RAW");
export const REACT_APP_DONATION_GUIDELINES_URL = get("REACT_APP_DONATION_GUIDELINES_URL");
export const REACT_APP_EMAIL_PLACEHOLDER = get("REACT_APP_EMAIL_PLACEHOLDER");
export const REACT_APP_THANK_YOU_REDIRECT = get("REACT_APP_THANK_YOU_REDIRECT");
export const REACT_APP_HOME_BG_IMAGE = get("REACT_APP_HOME_BG_IMAGE");
export const REACT_APP_LOGIN_BG_COLOR = get("REACT_APP_LOGIN_BG_COLOR");
export const REACT_APP_LOGIN_BG_IMAGE = get("REACT_APP_LOGIN_BG_IMAGE");
export const REACT_APP_SENTRY_DSN = get("REACT_APP_SENTRY_DSN");
export const REACT_APP_GTM_TOGGLE = get("REACT_APP_GTM_TOGGLE");
export const REACT_APP_GTM_ID = get("REACT_APP_GTM_ID");
export const REACT_APP_GOOGLE_ANALYTICS_TOGGLE = get("REACT_APP_GOOGLE_ANALYTICS_TOGGLE");
export const REACT_APP_GOOGLE_ANALYTICS = get("REACT_APP_GOOGLE_ANALYTICS");
export const REACT_APP_ORG_NAME = get("REACT_APP_ORG_NAME");
